import _extends from "@babel/runtime/helpers/extends";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { ProductEnvironment } from '@atlassian/forge-ui-types';
import ErrorPanel from '../components/UIKit1/errorPanel/errorPanel';
import { MetricsContext } from '../context';
import { captureAndReportError } from '../error-reporting';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { FORGE_UI_ANALYTICS_CHANNEL } from '../analytics';
export var ErrorWithCustomContent = /*#__PURE__*/function (_Error) {
  _inherits(ErrorWithCustomContent, _Error);
  var _super = _createSuper(ErrorWithCustomContent);
  function ErrorWithCustomContent(error) {
    var _this;
    _classCallCheck(this, ErrorWithCustomContent);
    _this = _super.call(this, error.logMessage);
    _this.errorTitle = error.errorTitle;
    _this.logMessage = error.logMessage;
    _this.errorBody = error.errorBody;
    return _this;
  }
  return _createClass(ErrorWithCustomContent);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var GenericErrorBoundaryWithCreateAnalyticsEvent = /*#__PURE__*/function (_Component) {
  _inherits(GenericErrorBoundaryWithCreateAnalyticsEvent, _Component);
  var _super2 = _createSuper(GenericErrorBoundaryWithCreateAnalyticsEvent);
  function GenericErrorBoundaryWithCreateAnalyticsEvent() {
    var _this2;
    _classCallCheck(this, GenericErrorBoundaryWithCreateAnalyticsEvent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "state", {
      thrownError: undefined
    });
    return _this2;
  }
  _createClass(GenericErrorBoundaryWithCreateAnalyticsEvent, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this$context = this.context,
        page = _this$context.page,
        environment = _this$context.environment;
      var createAnalyticsEvent = this.props.createAnalyticsEvent;
      captureAndReportError({
        error: error,
        errorInfo: errorInfo,
        page: page,
        environment: environment || ProductEnvironment.DEVELOPMENT
      });
      createAnalyticsEvent({
        eventType: OPERATIONAL_EVENT_TYPE,
        data: {
          action: 'failed',
          actionSubject: 'forge.ui.renderer',
          source: page,
          tags: ['forge'],
          attributes: {
            target: 'errorBoundary',
            errorName: error.name
          }
        }
      }).fire(FORGE_UI_ANALYTICS_CHANNEL);
      if (error instanceof ErrorWithCustomContent) {
        this.setState({
          thrownError: {
            error: {
              name: 'error',
              message: error.errorTitle,
              errorMessage: error.errorBody
            },
            errorInfo: errorInfo
          }
        });
      } else {
        this.setState({
          thrownError: {
            error: error,
            errorInfo: errorInfo
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var thrownError = this.state.thrownError;
      if (!thrownError) {
        return this.props.children;
      }
      return /*#__PURE__*/React.createElement(ErrorPanel, {
        error: thrownError.error,
        dispatch: this.props.dispatch
      });
    }
  }]);
  return GenericErrorBoundaryWithCreateAnalyticsEvent;
}(Component);
_defineProperty(GenericErrorBoundaryWithCreateAnalyticsEvent, "contextType", MetricsContext);
var GenericErrorBoundary = function GenericErrorBoundary(props) {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  return /*#__PURE__*/React.createElement(GenericErrorBoundaryWithCreateAnalyticsEvent, _extends({}, props, {
    createAnalyticsEvent: createAnalyticsEvent
  }));
};
export default GenericErrorBoundary;